<template>
  <div class="onlineRMA-landing container">
    <h1 class="onlineRMA-landing--heading">
      {{ translations.heading }}
    </h1>
    <div class="onlineRMA-landing__content">
      <FormKit
        id="exchange-form"
        v-model="internalFormValues"
        type="form"
        form-class="form"
        novalidate
        :actions="false"
        :incomplete-message="false"
        @submit="onDeviceVerificationSubmitted"
      >
        <FormKit
          name="selectedCountryRegion"
          data-test-id="country"
          type="select"
          validation="required"
          placeholder=" "
          :label="`${translations.orderInformationForm?.countryRegionLabel}*`"
          :options="getCountriesTransformed"
          :validation-messages="{
            required: translations.orderInformationForm.errors.fieldRequiredGeneric
          }"
          @input="analyticsInstance.triggerCountrySelectionAnalytics($event)"
        />
        <ScAccordion :cta="translations.orderInformationForm.countryRegionTooltipLink">
          {{ translations.orderInformationForm.countryRegionTooltipContent }}
        </ScAccordion>
        <FormKit
          name="serialNumber"
          data-test-id="sn"
          validation="required|alphanumeric"
          :maxlength="50"
          :label="`${translations.orderInformationForm.serialNumberLabel}*`"
          :validation-messages="{
            required: translations.orderInformationForm.errors.fieldRequiredGeneric,
            alphanumeric: translations.orderInformationForm.errors.invalidSerialNumberField,
          }"
        />
        <ScAccordion :cta="translations.orderInformationForm.serialNumberTooltipLinkText">
          {{ translations.orderInformationForm.serialNumberTooltipContent }}
        </ScAccordion>
        <FormKit
          name="emailAddress"
          data-test-id="email"

          type="email"
          validation="required|email"
          :help="translations.orderInformationForm.emailAddressTooltipContent"
          :label="`${translations.orderInformationForm.emailAddressLabel}*`"
          :validation-messages="{
            required: translations.orderInformationForm.errors.fieldRequiredGeneric,
            email: translations.orderInformationForm.errors.invalidEmailAddressField,
          }"
        />
        <div
          v-if="verificationFailureErrors.length"
          class="onlineRMA-landing__content__error error"
        >
          <div class="field-message">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="verificationFailureErrors[0]" />

            <a
              :href="provideErrorToProductPage
                ? getDeviceProductPageUrl : getProductNotIdentifiedLink"
              @click.prevent="
                onVerificationFailureLinkClicked({
                  event_category: 'ORMA Landing',
                  event_action: 'SN Validation',
                  event_label: 'Link to Support',
                  link: provideErrorToProductPage
                    ? getDeviceProductPageUrl : getProductNotIdentifiedLink
                })"
            >{{ translations.exceptionProductIdentifiedLinkText }}
            </a>
          </div>
        </div>
        <FormKit
          type="submit"
          :label="translations.orderInformationForm.submitButtonText"
          :disabled="submitDisabled"
        />
      </FormKit>
    </div>
  </div>
</template>

<script src="./index.js"></script>

<style lang="scss">
  @import './style.scss';
</style>
